import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import parse from 'html-react-parser';
import classes from './Checkbox.style.module.scss';

const Checkbox = ({
  id,
  className,
  label,
  onChange,
  value,
  required,
  dataTestId,
  labelDataTestId,
  ...restProps
}) => {
  const handleChange = (e) => (!onChange ? null : onChange(e.target.checked));
  return (
    <div className={classNames(classes.checkbox, className)}>
      <input
        type="checkbox"
        id={id}
        onChange={handleChange}
        defaultChecked={value}
        required={required}
        data-testid={dataTestId}
        {...restProps}
        aria-labelledby={`label-${id}`}
      />
      <label
        /* style={{
                    fontSize: label && label.length >= 30 && '14px',
                    lineHeight: label && label.length >= 30 && '20px'
                }} */
        htmlFor={id}
        data-testid={labelDataTestId}
        id={`label-${id}`}
        aria-hidden="true"
      >
        {parse(label)}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool,
  required: PropTypes.bool,
  dataTestId: PropTypes.string,
  labelDataTestId: PropTypes.string
};

Checkbox.defaultProps = {
  value: false,
  className: '',
  label: ''
};

export default Checkbox;
